module.exports = __webpack_public_path__ + "static/media/rocket.5856fd83.png";